module.exports = __webpack_public_path__ + "img/home-android-compat.941398bd.svg";